// src/components/TopBar.js
// Barra superior usada junto con el Sidebar (modo de menú "lateral"):
// trae el botón de menú (solo en móvil) y el menú de usuario.
import React from "react";
import { FaBars } from "react-icons/fa";
import UserMenu from "./UserMenu";
import NotificacionesBell from "./NotificacionesBell";

export default function TopBar({ onAbrirMenu }) {
  return (
    <div className="bg-white border-b border-slate-200 px-4 sm:px-6 py-2.5 flex justify-between md:justify-end items-center gap-2 shadow-sm">
      <button
        type="button"
        onClick={onAbrirMenu}
        aria-label="Abrir menú"
        className="md:hidden -ml-1 p-2 rounded-md text-slate-600 hover:bg-slate-100"
      >
        <FaBars className="text-lg" />
      </button>
      <div className="flex items-center gap-2">
        <NotificacionesBell />
        <UserMenu />
      </div>
    </div>
  );
}
